import { styled } from 'ui'

const BoxStyled = styled('div', {
  variants: {
    fixed: {
      true: {
        position: 'fixed'
      }
    },
    absolute: {
      true: {
        position: 'absolute'
      }
    },
    relative: {
      true: {
        position: 'relative'
      }
    },
    grid: {
      true: {
        display: 'grid'
      }
    },
    sticky: {
      true: {
        position: 'sticky'
      }
    },
    flex: {
      true: {
        display: 'flex',
        flexDirection: 'row'
      },
      rowReversed: {
        display: 'flex',
        flexDirection: 'row-reverse'
      },
      column: {
        display: 'flex',
        flexDirection: 'column'
      },
      columnReversed: {
        display: 'flex',
        flexDirection: 'column-reverse'
      }
    },
    items: {
      start: {
        alignItems: 'flex-start'
      },
      end: {
        alignItems: 'flex-end'
      },
      center: {
        alignItems: 'center'
      },
      stretch: {
        alignItems: 'stretch'
      }
    },
    justify: {
      start: {
        justifyContent: 'flex-start'
      },
      end: {
        justifyContent: 'flex-end'
      },
      center: {
        justifyContent: 'center'
      },
      between: {
        justifyContent: 'space-between'
      },
      around: {
        justifyContent: 'space-around'
      }
    },
    truncate: {
      true: {
        truncate: true
      }
    },
    textCenter: {
      true: {
        textAlign: 'center'
      }
    },
    removeScrollbar: {
      true: {
        'scrollbar-width': 'none',
        '-ms-overflow-style': 'none',
        '&::-webkit-scrollbar': {
          width: 0,
          height: 0
        }
      }
    }
  }
})

export default BoxStyled
